import { InjectionToken } from '@angular/core';
import { ISandboxConfig } from '@lms-approval/onehub-sandbox';

export const SANDBOX_CONFIG = new InjectionToken<ISandboxConfig>('SANDBOX_CONFIG');
